import { modalTypes, displayTypes } from './constants';

export const chooseWhenToDisplayItems = (displayType, displayItems) => {
    // const newItemToSet = {};

    switch (displayType) {
        case modalTypes.BEFORE_CLASS: {
            // newItemToSet.before = { data: { selected: displayType, ...displayItems } };
            // break;
            return 'before';
        }
        case modalTypes.DURING_CLASS: {
            // newItemToSet.during = { data: { selected: displayType, ...displayItems } };
            // break;
            return 'during';
        }
        case modalTypes.AFTER_CLASS: {
            // newItemToSet.after = { data: { selected: displayType, ...displayItems } };
            // break;
            return 'after';
        }
        default:
            return {};
    }
    // return newItemToSet;
};

export const convertDisplayTypeNumberToName = displayType => {
    switch (displayType) {
        case displayTypes.WORKOUT_EXERCISES:
            return 'Workout exercises';
        case displayTypes.WEARABLE_STATS:
            return 'Wearable stats';
        case displayTypes.WORKOUT_PLAYBACK:
            return 'Workout playback';
        case displayTypes.GENERAL_LEADERBOARDS:
            return 'General leaderboards';
        case displayTypes.WORKOUT_LEADERBOARDS:
            return 'Workout leaderboards';
        case displayTypes.YOUTUBE_VIDEO:
            return 'Youtube video';
        default:
            return 'None';
    }
};

/*
    https://www.youtube.com/watch?v=jwZmJLCkWec 
    to
    https://www.youtube.com/embed/jwZmJLCkWec
*/

export const convertWatchYoutubeLinkToEmbed = youtubeLink => {
    if (youtubeLink) {
        if (youtubeLink.includes('youtu.be')) {
            const videoId = youtubeLink.split('/').pop();
            return videoId;
        } else {
            const videoId = youtubeLink.split('v=').pop();
            return videoId;
        }
    }

    return '';
};



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/GymTv/utils.js